import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';

import { KYMW1407ImageInfoDetailBoxComponent } from './kymw1407-image-info-detail-box.component';


/**
 * 画像情報詳細ボックス モジュール設定クラス
 *
 * @export KYMW1407ImageInfoDetailBoxModule
 * @class KYMW1407ImageInfoDetailBoxModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1407ImageInfoDetailBoxComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW1407ImageInfoDetailBoxComponent,
  ]
})
export class KYMW1407ImageInfoDetailBoxModule {
}
